/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

export const ADD_TOAST = 'ADD_TOAST';
export const addToast = (success, title, message = '') => ({
  type: ADD_TOAST,
  title,
  success,
  message
});

export const EMPTY_TOASTER = 'EMPTY_TOASTER';
export const emptyToaster = () => ({
  type: EMPTY_TOASTER
});
